// Klyko: leitura da aceitação no carrinho lateral e na página do carrinho.
// Carregado pelo layout global para funcionar também quando a Shopify substitui
// o carrinho por AJAX, sem ser necessário atualizar a página.
const klykoConsentSelector = 'klyko-terms-consent';
const klykoCheckboxSelector = '[data-klyko-terms-input]';

function syncKlykoCheckoutConsent(consent) {
  if (!consent) return;
  const checkbox = consent.querySelector(klykoCheckboxSelector);
  const checkoutButton = consent.closest('.cart__ctas')?.querySelector('button[name="checkout"]');
  if (!checkbox || !checkoutButton) return;

  const enabled = checkbox.checked;
  checkoutButton.disabled = !enabled;
  checkoutButton.setAttribute('aria-disabled', String(!enabled));
}

// A ligação aos Termos e Condições é apenas para consulta.
// Só a alteração do visto deve ativar/desativar o checkout.
if (!customElements.get(klykoConsentSelector)) {
  customElements.define(klykoConsentSelector, class extends HTMLElement {
    connectedCallback() {
      syncKlykoCheckoutConsent(this);
    }
  });
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(klykoCheckboxSelector)) return;
  syncKlykoCheckoutConsent(input.closest(klykoConsentSelector));
}, true);

// Proteção complementar se a Shopify recriar o botão após a seleção.
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest('button[name="checkout"]');
  const consent = button?.closest('.cart__ctas')?.querySelector(klykoConsentSelector);
  if (!consent) return;
  const checked = !!consent.querySelector(klykoCheckboxSelector)?.checked;
  if (!checked) {
    event.preventDefault();
    event.stopImmediatePropagation();
    syncKlykoCheckoutConsent(consent);
  }
}, true);
